import { TableData } from "Utility/Types/status_identity_get_set";

export const deviceNameToID = (tableData: TableData[], name_or_id_list: string[]) => {
  return tableData.filter((device: any) => name_or_id_list.includes(device.name_or_id)).map((device: any) => device.id);
};
